{
  "name": "@awo-care/source",
  "engines": {
    "node": ">=24.0.0",
    "npm": ">=11.0.0"
  },
  "versionCustomer": "2.15.1",
  "buildDateCustomer": "2026-10-20 11:06:01",
  "versionEmployee": "1.80.0",
  "buildDateEmployee": "2026-10-20 11:06:01",
  "versionWebsite": "1.20.5",
  "buildDateWebsite": "2026-10-12 09:00:00",
  "license": "MIT",
  "scripts": {
    "e2e-prepare": "./run-e2e-contact.sh && firebase emulators:start",
    "e2e:smoke": "npx tsx scripts/smoke-chat.ts",
    "lint": "nx run-many --target=lint --all --maxParallel=100",
    "typecheck": "node scripts/typecheck.mjs",
    "worktree:clean": "node scripts/worktree-clean.mjs",
    "dev:stop": "node scripts/kill-port.mjs",
    "update-version": "node update-version.js all",
    "update-version:customer": "node update-version.js customer",
    "update-version:employee": "node update-version.js employee",
    "update-version:website": "node update-version.js website",
    "update-version:minor": "node update-version.js all minor",
    "update-version:major": "node update-version.js all major",
    "start": "node scripts/start-app.js",
    "start:customer": "nx run-many -t serve -p customer-ui",
    "start:employee": "nx run-many -t serve -p employee-ui",
    "start:website": "nx run-many -t serve -p website",
    "start:e2e": "cross-env CI=true nx run-many --target=serve --projects=customer-ui,employee-ui,website --configuration=e2e --maxParallel=100 --skip-nx-cache",
    "check:deps": "node scripts/check-deps-in-sync.js",
    "deploy:customer": "npm run check:deps && node scripts/prompt-version-update.js customer && nx run-many -t build --projects customer-ui --parallel --configuration=development && firebase use dev && firebase deploy --only hosting:customer-ui,firestore,storage",
    "deploy:employee": "npm run check:deps && node scripts/prompt-version-update.js employee && nx run-many -t build --projects employee-ui --parallel --configuration=development && firebase use dev && firebase deploy --only hosting:employee-ui,firestore,storage",
    "deploy:employee:auto": "npm run check:deps && node scripts/prompt-version-update.js employee skip && nx run-many -t build --projects employee-ui --parallel --configuration=development --skip-nx-cache && firebase use dev && firebase deploy --only hosting:employee-ui,firestore,storage",
    "deploy:website": "npm run check:deps && node scripts/prompt-version-update.js website && nx run-many -t build --projects website --parallel --configuration=development && firebase use dev && firebase deploy --only hosting:website,firestore,storage",
    "deploy:all": "npm run check:deps && node scripts/prompt-version-update.js all && nx run-many -t build --projects customer-ui,employee-ui,website --parallel --configuration=development && firebase use dev && firebase deploy --only hosting,firestore,storage",
    "deploy:customer:prod": "npm run check:deps && node scripts/prompt-version-update.js customer && nx run-many -t build --projects customer-ui --parallel --configuration=production && firebase use prod && firebase deploy --only hosting:customer-ui,firestore,storage",
    "deploy:employee:prod": "npm run check:deps && node scripts/prompt-version-update.js employee && nx run-many -t build --projects employee-ui --parallel --configuration=production && firebase use prod && firebase deploy --only hosting:employee-ui,firestore,storage",
    "deploy:website:prod": "npm run check:deps && node scripts/prompt-version-update.js website && nx run-many -t build --projects website --parallel --configuration=production && firebase use prod && firebase deploy --only hosting:website,firestore,storage",
    "deployprod:all:prod": "npm run check:deps && node scripts/prompt-version-update.js all && nx run-many -t build --projects customer-ui,employee-ui,website --parallel --configuration=production && firebase use prod && firebase deploy --only hosting,firestore,storage",
    "kb:seed:dev": "npx tsx scripts/seed-knowledgebase.ts --project=awo-care-dev",
    "kb:sync": "npx tsx scripts/sync-knowledgebase.ts",
    "kb:sync:dev": "npx tsx scripts/sync-knowledgebase.ts --project=awo-care-dev",
    "extract:customer": "nx extract-i18n customer-ui",
    "extract:employee": "nx extract-i18n employee-ui",
    "extract:website": "nx extract-i18n website && node scripts/create-clean-website-xlf.js",
    "translate:customer": "node node_modules/@solidgroup-agency/ai-auto-translate/bin.js translate",
    "translate:customer:status": "node node_modules/@solidgroup-agency/ai-auto-translate/bin.js status",
    "translate:customer:pull": "node node_modules/@solidgroup-agency/ai-auto-translate/bin.js pull",
    "translate:website": "node node_modules/@solidgroup-agency/ai-auto-translate/bin.js translate --config translate.website.config.json",
    "translate:website:status": "node node_modules/@solidgroup-agency/ai-auto-translate/bin.js status --config translate.website.config.json",
    "translate:website:pull": "node node_modules/@solidgroup-agency/ai-auto-translate/bin.js pull --config translate.website.config.json",
    "emulator": "node scripts/start-mailhog.js && node scripts/start-emulator-with-seed.js",
    "emulator:mailhog": "cross-env E2E_USE_MAILHOG=true npm run emulator",
    "emulator:functions": "firebase emulators:start --only functions",
    "seed-emulator": "node scripts/seed-emulator.js",
    "test:security-rules": "vitest run apps/security-rules-tests",
    "test:security-rules:watch": "vitest apps/security-rules-tests",
    "test:security-rules:ui": "vitest --ui apps/security-rules-tests",
    "check:no-jsdelivr": "node scripts/check-no-jsdelivr-dist.mjs",
    "test:unit": "vitest run --config vitest.unit.config.ts",
    "test:integration": "vitest run --config vitest.integration.config.ts",
    "test:unit:watch": "vitest --config vitest.unit.config.ts",
    "lock:check": "node scripts/lockfile-linux.mjs check",
    "postinstall": "node scripts/install-git-hooks.mjs",
    "lock:fix": "node scripts/lockfile-linux.mjs fix",
    "tel:kb:sync": "npx tsx scripts/elevenlabs/sync-elevenlabs-kb.ts",
    "tel:kb:sync:dev": "npx tsx scripts/elevenlabs/sync-elevenlabs-kb.ts --project=awo-care-dev",
    "tel:agent:provision": "npx tsx scripts/elevenlabs/provision-agent.ts"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.2.2",
    "@angular/cdk": "22.2.2",
    "@angular/common": "22.2.2",
    "@angular/compiler": "22.2.2",
    "@angular/core": "22.2.2",
    "@angular/forms": "22.2.2",
    "@angular/material": "22.2.2",
    "@angular/platform-browser": "22.2.2",
    "@angular/platform-browser-dynamic": "22.2.2",
    "@angular/platform-server": "22.2.2",
    "@angular/router": "22.2.2",
    "@angular/ssr": "22.2.2",
    "@fontsource/roboto": "^5.3.0",
    "@fontsource/source-sans-3": "^5.3.0",
    "@google/generative-ai": "^0.21.0",
    "@solidgroup-agency/feedback-widget": "1.5.1",
    "@solidgroup-agency/firebase-app-monitoring": "2.7.0",
    "@solidgroup-agency/ticket-system": "^2.35.0",
    "@solidgroup-agency/ticket-system-functions": "^2.3.0",
    "@solidgroup-agency/ui-dynamic-form": "^4.2.0",
    "@solidgroup-agency/ui-shared-components": "^3.4.1",
    "@solidgroup-agency/ui-table": "^3.4.2",
    "@types/dompurify": "^3.0.5",
    "dompurify": "^3.4.13",
    "dotenv": "^16.6.1",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "firebase": "^12.11.0",
    "firebase-functions": "^7.4.0",
    "flag-icons": "^7.5.0",
    "html-to-image": "^1.11.13",
    "html-to-text": "^9.0.5",
    "mammoth": "^1.8.0",
    "material-icons": "^1.13.14",
    "ng-recaptcha-2": "^22.0.1",
    "qrcode": "^1.5.3",
    "repomix": "^1.18.0",
    "rxjs": "~7.8.0",
    "sanitize-html": "^2.17.7"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "22.2.2",
    "@angular-devkit/core": "22.2.2",
    "@angular-devkit/schematics": "22.2.2",
    "@angular/build": "22.2.2",
    "@angular/cli": "22.2.2",
    "@angular/compiler-cli": "22.2.2",
    "@angular/google-maps": "22.2.2",
    "@angular/language-service": "22.2.2",
    "@angular/localize": "22.2.2",
    "@angular/service-worker": "22.2.2",
    "@emnapi/core": "^1.9.0",
    "@emnapi/runtime": "^1.9.0",
    "@eslint/js": "^9.8.0",
    "@faker-js/faker": "^10.5.0",
    "@firebase/rules-unit-testing": "^5.0.0",
    "@nx/angular": "23.3.0",
    "@nx/devkit": "23.3.0",
    "@nx/esbuild": "23.3.0",
    "@nx/eslint": "23.3.0",
    "@nx/eslint-plugin": "23.3.0",
    "@nx/js": "23.3.0",
    "@nx/playwright": "23.3.0",
    "@nx/web": "23.3.0",
    "@nx/workspace": "23.3.0",
    "@playwright/test": "^1.36.0",
    "@schematics/angular": "22.2.2",
    "@solidgroup-agency/ai-auto-translate": "^1.2.1",
    "@solidgroup-agency/gemini-knowledgebase": "^0.4.2",
    "@swc-node/register": "~1.12.1",
    "@swc/core": "~1.16.1",
    "@swc/helpers": "~0.5.11",
    "@types/file-saver": "^2.0.7",
    "@types/google.maps": "^3.58.1",
    "@types/html-to-text": "^9.0.4",
    "@types/node": "^20.19.9",
    "@types/qrcode": "^1.5.5",
    "@types/sanitize-html": "^2.13.0",
    "@typescript-eslint/eslint-plugin": "8.68.0",
    "@typescript-eslint/parser": "8.68.0",
    "@typescript-eslint/utils": "8.68.0",
    "angular-eslint": "22.2.0",
    "axe-core": "^4.12.1",
    "baseline-browser-mapping": "^2.9.7",
    "cross-env": "^10.1.0",
    "esbuild": "^0.28.2",
    "eslint": "^9.8.0",
    "eslint-config-prettier": "10.1.5",
    "eslint-plugin-playwright": "^1.6.2",
    "firebase-admin": "^14.5.0",
    "firebase-tools": "^15.33.0",
    "jsdom": "^27.4.0",
    "mustache": "^4.2.0",
    "ng-extract-i18n-merge": "^3.2.1",
    "nx": "23.3.0",
    "prettier": "^2.6.2",
    "ts-node": "10.9.1",
    "tslib": "^2.3.0",
    "typescript": "6.0.3",
    "typescript-eslint": "8.68.0",
    "vitest": "^4.0.18"
  },
  "overrides": {
    "@solidgroup/ui-shared-components": "$@solidgroup-agency/ui-shared-components",
    "firebase": "$firebase",
    "@babel/plugin-transform-modules-systemjs": "^7.29.8",
    "@hono/node-server@^1": "^1.19.15",
    "@opentelemetry/core": "^2.8.0",
    "@protobufjs/utf8": "^1.1.1",
    "@tootallnate/once": "^2.0.1",
    "axios": "^1.18.0",
    "basic-ftp": "^5.3.1",
    "body-parser@^1": "^1.20.6",
    "form-data@^2": "^2.5.6",
    "form-data@^4": "^4.0.6",
    "http-proxy-middleware@^2": "^2.0.10",
    "immutable": "^5.1.9",
    "js-yaml@^3": "^3.15.1",
    "js-yaml@^4": "^4.3.1",
    "launch-editor": "^2.14.1",
    "less": "^4.9.0",
    "morgan": "^1.11.0",
    "piscina@^4": "^4.9.3",
    "protobufjs": "^7.6.5",
    "qs": "^6.15.3",
    "shell-quote": "^1.9.0",
    "tar@^6": "^7.5.22",
    "tar@^7": "^7.5.22",
    "uuid@^8": "^11.1.1",
    "uuid@^9": "^11.1.1",
    "uuid@^11": "^11.1.1",
    "webpack-dev-server": "^5.2.6",
    "websocket-driver": "^0.7.5",
    "ws@^7": "^7.5.13",
    "@grpc/grpc-js": "^1.14.4",
    "body-parser@^2": "^2.3.0",
    "brace-expansion@^1": "^1.1.18",
    "brace-expansion@^2": "^2.1.4",
    "brace-expansion@^5": "^5.0.9",
    "fast-xml-builder": "^1.1.7"
  },
  "allowScripts": {
    "esbuild": true,
    "@firebase/util": true,
    "@google/genai": true,
    "@parcel/watcher": true,
    "@swc/core": true,
    "lmdb": true,
    "msgpackr-extract": true,
    "nx": true,
    "protobufjs": true,
    "re2": true
  },
  "packageManager": "npm@12.2.1"
}
